

export function HappyBirthdayCarousel(props: any) {
    if (!props?.isBirthDay) return null; // Ensure it renders only when it's a birthday

    return (
        <div className="card border-0 mb-0 pb-0">

            <img
                src={props.web_url}
                className="w-100 img-fluid desktopImage"
                alt="Birthday Wishes"
            />

            <img
                src={props.mobile_url}
                className="w-100 img-fluid mobileImage"
                alt="Birthday Wishes"
            />
            <div className="card-img-overlay text-start">
                <div className="row mb-4">
                    <div className="col-md-12 pt-3 ms-2 ms-md-5">
                        {props?.profileData?.oracle?.employee?.first_name ? (
                            <>
                                <h2 className="text-start mb-4">
                                    Happy Birthday, {props?.displayName}
                                </h2>
                                <p className="text-start">
                                    The TTEC family wishes you Happy Birthday!
                                </p>
                                <p className="text-start">
                                    We wish you all the good things that life can bring you
                                    on this special day!
                                </p>
                                <p className="text-start">TTEC Family</p>
                            </>
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    );
}
